import React from 'react';
import SvgIcon, {
 SvgIconProps,
} from '@mui/material/SvgIcon';

export default function CCMIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2.5 14.5c2.6 0 4.2 1.6 7.2 1.6 2.9 0 5.2-1.4 7.2-3.4l1.4-1.4a1.5 1.5 0 0 1 2.2 2.1L17 17.1c-1.8 1.9-3.9 3.2-6.8 3.2H2.5" />
        <path d="M12 10.32C9.74 8.92 8.57 7.59 8.57 6.19C8.57 5.17 9.35 4.47 10.28 4.47C11.06 4.47 11.69 4.94 12 5.56C12.31 4.94 12.94 4.47 13.72 4.47C14.65 4.47 15.43 5.17 15.43 6.19C15.43 7.59 14.26 8.92 12 10.32Z" />
      </g>
    </SvgIcon>
  );
}